var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.0439 4.77102C15.3913 5.12654 15.3847 5.69635 15.0292 6.04373L7.66039 13.2437C7.32445 13.572 6.79258 13.5867 6.439 13.2775L3.0078 10.2774C2.63361 9.95025 2.5955 9.38167 2.92267 9.00748C3.24985 8.63329 3.81843 8.59518 4.19262 8.92236L6.9975 11.3748L13.7712 4.75627C14.1267 4.4089 14.6966 4.4155 15.0439 4.77102Z"}));
}

Check.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Check;

Check.default = Check;
